<template>
<div>
  <div class="row">
    <div class="col-md-12">
      <q-stepper v-model="currentStep" ref="stepper" color="primary" animated>
        <q-step
            :name="1"
            title="Bestandsselectie"
            icon="add_to_photos"
            :done="step > 1"
        >
          <div class="row q-col-gutter-y-md">
            <CommonInput
                label="Bronbestand"
                type="file"
                :multiple="isMultiple"
                @change="guestType"
                name="file"
                id="file"
                class="col-12"
                outlined
            />
            <div class="col-12">
              <q-select
                  v-model="formdata.filetype"
                  :options="fileTypeOptions"
                  :label="Bestandstype"
                  class="text-neutral-90"
                  outlined
                  map-options
                  emit-value
                  :error-message="$errorMessage('fileType')"
                  :error="!!$hasError('fileType')"
              />
            </div>
            <div class="col-12 text-right">
              <accent-button @click="getAvailableFields"
                             class="btn btn-accent"
                             :disabled="formdata.files === null || processing">
                Volgende
              </accent-button>
            </div>
          </div>
        </q-step>

        <q-step
            :name="2"
            title="Configureer import"
            icon="create_new_folder"
            :done="step > 2"
        >
          <div class="col-md-12">
            <strong>Geef aan hoe de informatie in dit bestand is opgebouwd</strong>

            <div class="row">
              <div class="col-md-6">
                <q-radio label="Inladen als meerdere kaarten" v-model="formdata.maptype" :val="MAP_TYPE_MULTI" />
              </div>
              <div class="col-md-6">
                <q-radio label="Inladen als enkele kaart" v-model="formdata.maptype" :val="MAP_TYPE_SINGLE" />
              </div>
            </div>

            <template v-if="formdata.maptype == MAP_TYPE_MULTI">
              <q-select
                  v-model="formdata.titlebinding"
                  :options="titleBindingOptions"
                  label="Welk veld bevat de kaartnaam"
                  class="text-neutral-90"
                  outlined
                  map-options
                  emit-value
              />
              <q-checkbox v-model="formdata.groupbytitle" label="Groepeer kaarten met dezelfde naam" />
            </template>
            <template v-else>
              <common-input
                  v-model="formdata.title"
                  label="Kaartnaam"
                  class="q-mb-sm"
              />
            </template>
            <q-select
                v-model="formdata.projection"
                :options="projectionOptions"
                label="Kaart Projectie"
                class="text-neutral-90 q-my-sm"
                outlined
                map-options
                emit-value
            />
            <div class="row" v-if="mapGroupOptions.length">
              <div class="col-6">
                <q-select
                    v-model="formdata.mapgroup"
                    :options="mapGroupOptions"
                    label="Toevoegen aan bestaande groep"
                    class="text-neutral-90 q-my-sm"
                    outlined
                    :disable="!!formdata.newMapName"
                    emit-value
                    required
                />
              </div>
              <div class="col-6">
                <CommonInput
                    class="text-neutral-90 q-my-sm"
                    label="Of maak een nieuwe groep"
                    v-model="formdata.newMapName"
                    clearable>
                </CommonInput>
              </div>
            </div>
            <CommonInput
                v-else
                class="text-neutral-90 q-my-sm"
                label="Kaartgroep naam"
                v-model="formdata.newMapName"
                clearable />
            <div class="q-my-md">
              <q-btn @click="addFilter"
                     icon="add">
                Filter toevoegen
              </q-btn>

              <template v-for="filter in formdata.filters">
                <div class="row">
                  <div class="col-md-6">
                    <q-select class="form-control"
                              v-model="filter.field"
                              :options="titleBindingOptions"
                              map-options
                              emit-value>
                    </q-select>
                  </div>

                  <div class="col-md-2">
                    <q-select class="form-control"
                              v-model="filter.operator"
                              :options="[
                                  {value: '>', label:'&gt;' },
                                  {value: '<', label:'&lt;' },
                                  {value: '=', label:'&equals;' },
                              ]"
                              map-options
                              emit-value>
                    </q-select>
                  </div>

                  <div class="col-md-3">
                    <common-input v-model="filter.value" />
                  </div>
                  <div class="col-md-1">
                    <q-btn @click="removeFilter(filter)"
                           icon="delete"
                           round>
                    </q-btn>
                  </div>
                </div>
              </template>
            </div>
            <div class="col-12">
              <accent-button @click="back"
                             class="btn btn-accent q-mr-md"
                             :disabled=" processing">
                Vorige
              </accent-button>
              <accent-button @click="doImport"
                             class="btn btn-accent"
                             :disabled=" processing">
                Volgende
              </accent-button>
            </div>
          </div>
        </q-step>
        <q-step
            :name="3"
            title="Klaar"
            icon="map"
        >
          <div class="row q-col-gutter-y-md">
            <div class="col-md-12">
              <strong> Er zijn {{ results.length }} kaarten zijn ingeladen:</strong>
            </div>

            <div class="col-md-3 ">
              <q-list bordered separator>
                <q-item
                    clickable
                    v-for="map in results"
                    :key="map.id"
                    @click="toggleVisibleMap(map.id)"
                >
                  <q-item-section
                      avatar
                  >
                    <q-icon v-if="visibleMapId === map.id" name="visibility_off" />
                    <q-icon v-else name="visibility" />
                  </q-item-section>
                  <q-item-section>
                    {{ map.title }}
                  </q-item-section>
                </q-item>
              </q-list>
            </div>
            <BaseMap
                class="col-md-9"
                auto-fit
                auto-fit-always
                :geometry="selectedGeometry"
                :is-loading="geometryLoading"
                width="100%"
                height="400px"
            />
            <div class="col-md-12">
              <q-btn @click="again">Meer kaarten inladen</q-btn>
              <q-btn @click="undoImport">Ongedaan maken</q-btn>
              <q-btn @click="done">Klaar</q-btn>
            </div>
          </div>
        </q-step>
      </q-stepper>
    </div>
  </div>
  <div v-if="error" class="q-mt-md">
    <strong>Het bestand kan niet worden gelezen:</strong><br>
    {{ error }}
  </div>
</div>
</template>

<script>
import AccentButton from '../../../components/button/AccentButton.vue'

const FILE_TYPE_SHAPE = 'Shape'
const FILE_TYPE_SHAPE_ZIP = 'Shape zip'
const FILE_TYPE_GEOJSON = 'GeoJSON'
const FILE_TYPE_KML = 'KML'

export default {
  components: { AccentButton },
  props: {
    mapgroups: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      FILE_TYPE_SHAPE,
      FILE_TYPE_SHAPE_ZIP,
      FILE_TYPE_GEOJSON,
      FILE_TYPE_KML,

      MAP_TYPE_SINGLE: 'single',
      MAP_TYPE_MULTI: 'multi',

      formdata: {
        maptype: null,
        filetype: null,
        filters: [],
        titlebinding: '',
        groupbytitle: false,
        title: '',
        files: null,
        projection: '',
        newMapName: '',
        mapgroup: '',
      },

      currentStep: 1,
      filterIndex: 0,
      processing: false,
      geometryLoading: false,
      visibleMapId: null,
      fullImportGeometry: null,
      results: [],
      availableFields: [],
      error: '',
      selectedGeometry: null,
      fileTypeOptions: [
        {
          value: FILE_TYPE_SHAPE,
          label: 'Shape bestanden (los)',
        },
        {
          value: FILE_TYPE_SHAPE_ZIP,
          label: 'Zipbestand met shape bestanden',
        },
        {
          value: FILE_TYPE_GEOJSON,
          label: 'GeoJSON',
        },
        {
          value: FILE_TYPE_KML,
          label: 'KML',
        },
      ],
      projectionOptions: [
        { value: '4326', label: 'Standaard (53.3, 4.3)' },
        { value: '28992', label: 'Rijksdriehoek (429014.30841097, 187230.55604951)' },
      ],
    }
  },
  computed: {
    isMultiple () {
      return this.formdata.filetype === this.FILE_TYPE_SHAPE
    },
    titleBindingOptions () {
      return this.availableFields.map(({ field, example }) => ({
        value: field,
        label: `${field} (voorbeeld: ${example})`,
      }))
    },
    mapGroupOptions () {
      const titles = []
      for (const { title } of this.mapgroups) {
        if (!titles.includes(title)) {
          titles.push(title)
        }
      }
      return titles
    },
  },
  methods: {
    guestType () {
      this.formdata.files = this.$el.querySelector('input[type="file"]').files

      if (this.formdata.files.length > 1) {
        this.formdata.filetype = this.FILE_TYPE_SHAPE
      } else {
        switch (this.formdata.files[0].type) {
          case 'application/zip':
            this.formdata.filetype = this.FILE_TYPE_SHAPE_ZIP
            break
          case 'application/vnd.google-earth.kml+xml':
            this.formdata.filetype = this.FILE_TYPE_KML
            break
          default:
            this.formdata.filetype = this.FILE_TYPE_GEOJSON
            break
        }
      }
    },
    getAvailableFields () {
      this.processing = true
      const data = new FormData()
      data.set('Content-Type', 'multipart/form-data')

      for (let i = 0; i < this.formdata.files.length; i++) {
        data.append(`mapfiles[${i}]`, this.formdata.files[i])
      }

      if (this.formdata.filetype === this.FILE_TYPE_SHAPE_ZIP) {
        data.set('is_zipped', true)
        this.formdata.filetype = this.FILE_TYPE_SHAPE
      }

      data.set('type', this.formdata.filetype)
      this.error = null

      axios.post(this.$route('mapimport.setFile'), data).then(({ data }) => {
        this.processing = false
        this.availableFields = data
        this.currentStep = 2
      }).catch(({ response }) => {
        this.processing = false
        console.error(response)
        this.error = JSON.stringify(response.data)
      })
    },
    groupSelected (group) {
      this.formdata.mapgroup = group
    },
    addFilter () {
      this.filterIndex++
      this.formdata.filters.push({
        id: this.filterIndex,
        field: null,
        operator: '=',
        value: '',
      })
    },
    removeFilter (filter) {
      let index = this.formdata.filters.findIndex(item => item.id === filter.id)
      if (index !== -1) {
        delete this.formdata.filters[index]
      }
    },
    doImport () {
      this.processing = true
      this.error = null
      let data = {
        type: this.formdata.filetype,
        projection: this.formdata.projection,
        filters: this.formdata.filters,
      }

      if (this.formdata.maptype === this.MAP_TYPE_MULTI) {
        data.groupbytitle = this.formdata.groupbytitle
        data.titlebinding = this.formdata.titlebinding
      } else {
        data.singleMap = true
        data.title = this.formdata.title
      }

      if (!!this.formdata.newMapName) {
        data.mapgroup = this.formdata.newMapName
      } else {
        data.mapgroup = this.formdata.mapgroup
      }

      axios.post(this.$route('mapimport'), data)
          .then(({ data }) => {
            this.processing = false
            this.results = data
            this.currentStep = 3
            if (data.length) {
              this.showFullImportMap()

            }
          })
          .catch(({ response }) => {
            this.processing = false
            console.error(response)
            this.error = JSON.stringify(response.data)
          })
    },
    undoImport () {
      this.processing = true
      axios.post(this.$route('mapimport.undo'))
          .then(() => {
            this.processing = false
            this.again()
          })
          .catch(({ response }) => {
            this.processing = false
            console.error(response)
            this.error = response.data.error
          })
    },
    back () {
      this.currentStep--
      this.error = null
    },
    again () {
      location.reload()
    },
    done () {
      this.$goto('mapgroup.index')
    },
    toggleVisibleMap (mapId) {
      if (this.visibleMapId === mapId) {
        this.visibleMapId = null
        return this.showFullImportMap()
      }
      this.visibleMapId = mapId
      this.highlightMap(mapId)
    },
    highlightMap (mapId) {
      axios.get(
          this.$route('api.map.show', { map: mapId }),
      ).then(({ data }) => {
        if (this.visibleMapId !== mapId) {
          return
        }
        this.selectedGeometry = data
      }).catch((e) => {
        console.log(e)
      }).finally(() => {
        this.geometryLoading = false
      })
    },
    showFullImportMap () {
      if(this.fullImportGeometry){
        this.selectedGeometry = this.fullImportGeometry
        return
      }
      this.geometryLoading = true
      axios.post('/api/map/combine', {
        map_ids: this.results.map(({ id }) => id),
      }).then(({ data }) => {
        this.selectedGeometry = data
        this.fullImportGeometry = data
      }).catch((e) => {
        console.log(e)
      }).finally(() => {
        this.geometryLoading = false
      })
    },
  },
  mounted () {
    this.formdata.filetype = this.FILE_TYPE_SHAPE
    this.formdata.maptype = this.MAP_TYPE_MULTI
    this.currentStep = 1
  },
}
</script>

<style lang="scss" scoped>
.results {
  overflow-y: auto;
  border: 1px solid #d0d0d0;
  padding: 0;
  max-height: 300px;

  background: white;
  list-style: none;

  li {
    padding: 3px 5px 2px;
    cursor: pointer;

    &.active {
      background-color: lightskyblue;
    }
  }
}
</style>
